<template>
  <svg
    width="108"
    height="120"
    viewBox="0 0 108 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M108 69.7767C108 70.5074 107.984 71.2318 107.953 71.9543C107.304 87.0972 99.9204 100.495 88.7204 109.23C80.2449 115.84 69.5837 119.777 58 119.777C45.1531 119.777 33.4408 114.934 24.5857 106.971C18.4184 101.428 13.6388 94.3747 10.8265 86.3931C8.99592 81.1931 8 75.6012 8 69.7767C8 42.1625 30.3857 19.7767 58 19.7767C74.7571 19.7767 89.5878 28.0196 98.6592 40.6706C103.72 47.7278 106.99 56.1563 107.802 65.2931C107.933 66.7686 108 68.2645 108 69.7767Z"
      fill="#6C6C6C"
    />
    <path
      d="M107.804 65.2931C97.2138 64.8849 69.3914 62.6604 70.1363 58.3809C71.2016 52.2625 101.253 54.9217 101.253 51.4645C101.253 48.0074 86.6261 51.4645 86.6261 45.8809C86.6261 42.5666 92.7118 41.2196 98.6607 40.6707C103.722 47.7278 106.991 56.1564 107.804 65.2931Z"
      fill="#F0EEEE"
    />
    <path
      d="M30.1735 77.7911C30.1735 81.5115 17.6347 81.4544 9.26531 81.0033C8.43673 77.3952 8 73.636 8 69.7768C8 66.7931 8.26122 63.8686 8.76327 61.0278H8.76531C16.5449 61.8054 24.5878 63.5789 24.5878 67.1523C24.5878 72.4707 9.16327 69.2809 9.16327 72.4707C9.16327 75.6625 30.1735 72.2054 30.1735 77.7911Z"
      fill="#F0EEEE"
    />
    <path
      d="M88.7186 109.23C80.2431 115.84 69.5818 119.777 57.9982 119.777C45.1512 119.777 33.439 114.934 24.5839 106.971C23.9247 106.379 23.2818 105.768 22.6574 105.142C17.4165 99.9093 13.337 93.5215 10.8247 86.393L36.1267 65.2195L55.3023 81.2664L88.7186 109.23Z"
      fill="#A2A0A0"
    />
    <path
      d="M107.954 71.9543C107.305 87.0971 99.9216 100.495 88.7216 109.23C83.5992 113.226 77.6787 116.244 71.2379 118.007C67.0216 119.16 62.5828 119.777 58.0012 119.777C45.1543 119.777 33.442 114.934 24.5869 106.971L55.3053 81.2665L87.193 54.5808L107.954 71.9543Z"
      fill="#C8C6C6"
    />
    <path
      d="M88.7194 109.23C80.2439 115.84 69.5827 119.777 57.999 119.777C45.1521 119.777 33.4398 114.934 24.5847 106.971C23.9255 106.379 23.2827 105.768 22.6582 105.142L36.1276 65.2195L55.3031 81.2664L88.7194 109.23Z"
      fill="#C8C6C6"
    />
    <path
      d="M87.193 54.5808L71.2379 118.007C67.0216 119.16 62.5828 119.777 58.0012 119.777C45.1543 119.777 33.442 114.934 24.5869 106.971L55.3053 81.2665L87.193 54.5808Z"
      fill="#A2A0A0"
    />
    <g filter="url(#filter0_ddd_1001_3974)">
      <path
        d="M40.6289 49.4623C49.3489 48.2639 55.4465 40.2234 54.2481 31.5033C53.0497 22.7832 45.0092 16.6857 36.2891 17.8841C27.569 19.0825 21.4715 27.123 22.6699 35.8431C23.8683 44.5631 31.9088 50.6607 40.6289 49.4623Z"
        fill="#EFEDEE"
      />
    </g>
    <path
      d="M45.7103 30.0323C45.2829 30.2482 44.7611 30.077 44.545 29.6492L43.6792 27.9358C43.4633 27.5084 43.6349 26.9864 44.0622 26.7705C44.4896 26.5545 45.0116 26.7261 45.2275 27.1535L46.0933 28.867C46.3094 29.2947 46.1377 29.8163 45.7103 30.0323Z"
      fill="#3A484A"
    />
    <path
      d="M47.7775 31.5533L45.7064 32.5998C45.279 32.8157 44.757 32.6442 44.5411 32.2168C44.3251 31.7894 44.4967 31.2674 44.9241 31.0515L46.9952 30.005C47.423 29.7888 47.9446 29.9606 48.1606 30.388C48.3765 30.8154 48.2053 31.3372 47.7775 31.5533Z"
      fill="#F98084"
    />
    <path
      d="M30.0658 37.9374C29.6384 38.1533 29.1166 37.9822 28.9005 37.5544L28.0347 35.8409C27.8188 35.4135 27.9903 34.8916 28.4177 34.6756C28.8455 34.4595 29.3671 34.6312 29.583 35.0586L30.4488 36.7721C30.6649 37.1999 30.4935 37.7213 30.0658 37.9374Z"
      fill="#3A484A"
    />
    <path
      d="M32.1379 39.4558L30.0667 40.5023C29.6389 40.7184 29.1173 40.5466 28.9014 40.1192C28.6855 39.6919 28.8566 39.1701 29.2844 38.9539L31.3556 37.9075C31.783 37.6915 32.305 37.8631 32.5209 38.2905C32.7368 38.7178 32.5653 39.2398 32.1379 39.4558Z"
      fill="#F98084"
    />
    <path
      d="M38.8782 35.9409C38.1095 36.3293 37.2247 36.372 36.4497 36.0586C36.0058 35.879 35.7915 35.3732 35.9714 34.929C36.1509 34.4851 36.6568 34.2708 37.1009 34.4507C37.4115 34.5763 37.7742 34.5551 38.0959 34.3926C38.4176 34.23 38.6498 33.9506 38.733 33.6261C38.8516 33.1618 39.3238 32.8819 39.7881 33.0006C40.252 33.1194 40.5321 33.5921 40.4132 34.056C40.2062 34.8656 39.6469 35.5525 38.8782 35.9409Z"
      fill="#3A484A"
    />
    <defs>
      <filter
        id="filter0_ddd_1001_3974"
        x="0.519562"
        y="0.733765"
        width="75.8788"
        height="77.8788"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="7" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1001_3974"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1001_3974"
          result="effect2_dropShadow_1001_3974"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="8.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1001_3974"
          result="effect3_dropShadow_1001_3974"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1001_3974"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'UnsignedEmpty'
}
</script>
